import _path from "path";
import _pathType from "path-type";
import _process from "process";
var exports = {};
var process = _process;
const path = _path;
const pathType = _pathType;

const getExtensions = extensions => extensions.length > 1 ? `{${extensions.join(",")}}` : extensions[0];

const getPath = (filepath, cwd) => {
  const pth = filepath[0] === "!" ? filepath.slice(1) : filepath;
  return path.isAbsolute(pth) ? pth : path.join(cwd, pth);
};

const addExtensions = (file, extensions) => {
  if (path.extname(file)) {
    return `**/${file}`;
  }

  return `**/${file}.${getExtensions(extensions)}`;
};

const getGlob = (directory, options) => {
  if (options.files && !Array.isArray(options.files)) {
    throw new TypeError(`Expected \`files\` to be of type \`Array\` but received type \`${typeof options.files}\``);
  }

  if (options.extensions && !Array.isArray(options.extensions)) {
    throw new TypeError(`Expected \`extensions\` to be of type \`Array\` but received type \`${typeof options.extensions}\``);
  }

  if (options.files && options.extensions) {
    return options.files.map(x => path.posix.join(directory, addExtensions(x, options.extensions)));
  }

  if (options.files) {
    return options.files.map(x => path.posix.join(directory, `**/${x}`));
  }

  if (options.extensions) {
    return [path.posix.join(directory, `**/*.${getExtensions(options.extensions)}`)];
  }

  return [path.posix.join(directory, "**")];
};

exports = async (input, options) => {
  options = {
    cwd: process.cwd(),
    ...options
  };

  if (typeof options.cwd !== "string") {
    throw new TypeError(`Expected \`cwd\` to be of type \`string\` but received type \`${typeof options.cwd}\``);
  }

  const globs = await Promise.all([].concat(input).map(async x => {
    const isDirectory = await pathType.isDirectory(getPath(x, options.cwd));
    return isDirectory ? getGlob(x, options) : x;
  }));
  return [].concat.apply([], globs); // eslint-disable-line prefer-spread
};

exports.sync = (input, options) => {
  options = {
    cwd: process.cwd(),
    ...options
  };

  if (typeof options.cwd !== "string") {
    throw new TypeError(`Expected \`cwd\` to be of type \`string\` but received type \`${typeof options.cwd}\``);
  }

  const globs = [].concat(input).map(x => pathType.isDirectorySync(getPath(x, options.cwd)) ? getGlob(x, options) : x);
  return [].concat.apply([], globs); // eslint-disable-line prefer-spread
};

export default exports;
export const sync = exports.sync;